import Webservice from './Webservice';

export default class StoreWebservice extends Webservice {
  associateOrganization(id: string, params: object, sessionToken: string) {
    let data: any = params

    data['session_token'] = sessionToken;

    return this.client.post(
      `/v1/stores/${id}/associate_organization`,
      {
        data: {
          attributes: params
        },
      },
      {
        headers: {
          Authorization: sessionToken
        }
      }
    );
  }

  checkSessionToken(id:string, sessionToken: string) {
    return this.client.post(
      `/v1/stores/${id}/check_session`,
      {
        data: {
          attributes: {
            session_token: sessionToken
          }
        },
      },
      {
        headers: {
          Authorization: sessionToken
        }
      }
    );
  }

  fetchStore(id: string, sessionToken: string) {
    return this.client.get(
      `/v1/stores/${id}`,
      {
        headers: {
          Authorization: sessionToken
        }
      }
    );
  }

  getPaymentMethods(id: string, sessionToken: string) {
    return this.client.get(
      `/v1/stores/${id}/payment_methods`,
      {
        headers: {
          Authorization: sessionToken
        }
      }
    );
  }

  savePaymentMethods(id: string, sessionToken: string, allowedPaymentMethods: Array<string>) {
    return this.client.post(
      `/v1/stores/${id}/payment_methods`,
      {
        data: {
          attributes: {
            payment_methods: allowedPaymentMethods
          }
        },
      },
      {
        headers: {
          Authorization: sessionToken
        }
      }
    );
  }
}
